export const buildPublicAssetPath = (relativePath) =>
  `${process.env.PUBLIC_URL}${encodeURI(relativePath)}`;
